/*** 
 * 创建人：李珊
 * 时间：2021-3-24
 * 描述：基础数据：通用字典的主页面 展示数据 查询 重置 分页
 */
 import { Component, OnInit, ViewChild } from '@angular/core';
 import { DictionaryAddComponent } from '../dictionary-add/dictionary-add.component';
 import { DictionaryViewComponent } from "../dictionary-view/dictionary-view.component"
 import {SwMassageBoxService} from "../../../../../librarys/serves/sw-massage-box.service";
 import {KmsService} from 'src/app/areas/kms/kms.service';
 import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
 import { environment } from 'src/environments/environment';
 import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
 import {SwTreeComponent} from "../../../../../librarys/components/basic-components/sw-tree/sw-tree.component";
 import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
 import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
 import { SwToolbarComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-toolbar/sw-toolbar.component';
 
 @Component({
  selector: 'app-dictionary-query',
  templateUrl: './dictionary-query.component.html',
  styleUrls: ['./dictionary-query.component.css']
})
export class DictionaryQueryComponent implements OnInit {
 
   pid = ""; //树的父级Id
   grid: any=[]; //表格数据
   selectData:any = {}; //查询
   dictionaryName:string  //双向绑定的查询条件
   dictionaryValue:string  //双向绑定的查询条件
   treeList: any = [];  //左边的树
 
   asyncNodeUrl = environment.seekerWebAPI+ 'dictionary/queryPageList';
   selected:any = {}; //选中数据
   pageBase: any = {orderBy: null}  //分页数组
   ifShow:boolean=true; //隐藏左边面板
 
   showLeft:boolean = true  //是否展示左侧菜单
   listStatus = [{id:true,text:"启用"},{id:false,text:"禁用"}];
   isLoading: boolean = false;
   @ViewChild('add') add: DictionaryAddComponent; //新增组件
   @ViewChild('view') view: DictionaryViewComponent; //查看组件
 
   @ViewChild("swtree") swtree: SwTreeComponent; //树列表
   @ViewChild("tirm") tirm: SwMassageConfirmComponent; //选择确认框
   @ViewChild("swtable") swtable: SwGridTableComponent; //表格组件
   @ViewChild("swtoolbar") swtoolbar: SwToolbarComponent
   constructor(
     private box:SwMassageBoxService,//消息框
     private create:SwCreateModalComponentService,
     private systemId:SystemIdService,
     private service : KmsService //请求服务
   ) { }
 
   ngOnInit() {
     this.systemId.systemIdUpdated.subscribe(data=>{
       this.swtree.location();
       this.location();
   })
     this.location();
   }
 
   //表单数据
   location(){
     this.isLoading = true;
     //创建请求对象数据
     let orderByStr = this.pageBase.orderBy;
     this.selectData.parentId = this.pid
     this.selectData.systemId = this.systemId.getSystemId()
     let params =  {"param":{pageNum:this.pageBase.current,pageSize:this.pageBase.size,orderBy:this.pageBase.orderBy},
       "entity":this.selectData}
       //请求数据
      this.service.queryDictionaryPageList(params).subscribe(data=>{
        this.isLoading = false;
         if(data["code"] == 200){
           //绑定数据
           this.grid = data["data"]["records"];
           //绑定分页数据
           this.pageBase = data["data"];
           this.pageBase.orderBy = orderByStr;
         }
       });
   }
 
   //获取树型数据
   treeMenu(){
     let arr = [];
     //请求参数
     let params = {"param":{pageSize:0}};
     //请求数据
     this.service.queryDictionaryPageList(params).subscribe(data=>{
         if(data["code"] ==200){
           //获取到数据 将根结点数据展开
           data["data"]["records"].forEach(element => {
             if(element.parentId ==="0"){
               element.expanded = true;
             }else {
               element.expanded = false;
             }
             arr.push(element);
           });
           //绑定数据
           this.treeList = arr;
         }
       }
     )
   }
 
   //树点击
   onVoted(event){
     this.pid = event.key;
     this.pageBase = {current: 1, size: 10}
     this.location();
   }
 
   //单选
   outSelectData(event){
     this.selected =event;
     this.swtoolbar.enableToobar("all");//启用全部按钮
     if(event.status == true){
       this.swtoolbar.disableToolbar("ok");//禁用启用按钮
     } else if(event.status == false) {
       this.swtoolbar.disableToolbar("disable")//禁用禁用按钮
     }
   }
   //查询
   clickSelect(){
     this.selectData.dictionaryName = this.dictionaryName
     this.selectData.dictionaryValue = this.dictionaryValue
     this.pageBase.current = 1;
     this.selected = {};
     this.location();
   }
 
   //重置
   clickReload(){
     this.dictionaryName = ""
     this.dictionaryValue = ""
     //重置查询对象
     this.selectData = {};
     //清除选中 初始化表格
     this.selected = {};
     this.pageBase = {current: 1, size: 10}
     this.location();
   }
 
   //新增回调
   updateCallback(){
     this.selected = {};
     this.location();
     this.swtree.location();
   }
 
   //按钮点击事件
   onOperation(event){
     switch(event) {
       case "add":this.clickAdd();break;//新增
       case "modify":this.clickUpdate();break;//修改
       case "view":this.clickRead();break;//查看
       case "ok":this.clickEnable();break;//启用
       case "disable":this.clickDisable();break;//禁用
       case "delete":this.clickDelete();break;//删除
       case "export":this.clickExport();break;//导出
     }
   }
 
   //查看
   clickRead(){
     if(this.selected.dictionaryId == null){
       this.box.danger("请选择一条数据");
     }else{
       //初始化查看方法
       this.create.createModal(DictionaryViewComponent,this.selected.dictionaryId)
     }
   }
 
   //增加
   clickAdd(){
     let param = {"view": "Add", "viewData": this.pid}
     this.create.createModal(DictionaryAddComponent,param,this.updateCallback.bind(this))
   }
 
   //修改
   clickUpdate(){
     if(this.selected.dictionaryId == null){
       this.box.danger("请选择一条数据");
     }else{
       let param = {"view": "Edit", "viewData": this.selected}
       this.create.createModal(DictionaryAddComponent,param,this.updateCallback.bind(this))
     }
   }
 
   //删除
   clickDelete(){
     if(this.selected.dictionaryId == null){
       this.box.danger("请选择一条数据");
     }else{
       //删除确定提示框
       this.tirm.openCLick("确认删除吗？",(data)=>{
         if(data){
           //请求数据提示框
           let ids ={delIds: [this.selected.dictionaryId]}
           this.service.deleteDictionary(ids).subscribe(data=>{
             if(data["code"] ==200){
               //提示
               this.box.success("操作成功");
               //重置选中
               this.selected = {};
               //初始化表格
               this.location();
               //初始化树型数据
               this.treeMenu();
               this.swtree.location();
               //刷新新增数据
               this.add.delReload();
             }else{
               this.box.danger(data["msg"]);
             }
           })
         }
       })
     }
   }
 
   //导出
   clickExport(){
     if(this.pid == ""){
       this.box.danger("请选择左侧数据导出");
     }else{
       this.service.exportDictionary(this.pid);
     }
   }
 
   //启用
   clickEnable(){
     if(this.selected.dictionaryId == null){
       this.box.danger("请选择一条数据");
     }else{
       //启用发送请求
       let value ={dictionaryId:this.selected.dictionaryId,status:true}
       this.service.updateDictionary(value).subscribe(data=>{
         if(data["code"] ==200){
 
           this.box.success("操作成功");
            //清空选中
           //初始化方法
           this.selected = {};
           this.swtree.location();
           this.location();
         }else{
           this.box.waring(data["msg"]);
         }
       })
     }
 
   }
 
   //禁用
   clickDisable(){
     if(this.selected.dictionaryId == null){
       this.box.danger("请选择一条数据");
     }else{
        //禁用请求数据
       let value ={dictionaryId:this.selected.dictionaryId,status:false}
       this.service.updateDictionary(value).subscribe(data=>{
         if(data["code"] ==200){
           this.box.success("操作成功");
           //清空选中
           //初始化方法
           this.selected = {};
           this.swtree.location();
           this.location();
         }else{
           this.box.waring(data["msg"]);
         }
       })
     }
   }
 
   //发生变化时触发
   clickPageQuery(event){
     this.pageBase = event;
     this.selected = {};
     this.location();
   }
 
 //展示中文数据
   getName(id) {
     const tem1 = this.listStatus.filter(item => item['id'] == id)
     if(tem1.length){
       return tem1[0].text
     }
   }
   //隐藏左边面板
   showStyle(data) {
     this.showLeft=!data;
   }
 }
 
